export const toBase64 = (data: string): string =>
  btoa(String.fromCodePoint(...new TextEncoder().encode(data)));

export const base64ToBytes = (data: string): Uint8Array<ArrayBuffer> =>
  Uint8Array.from(atob(data), (c) => c.charCodeAt(0));

export const fromBase64 = (data: string): string => new TextDecoder().decode(base64ToBytes(data));
